import ComponentsSelector from "./ComponentsSelector";
import {
  buildMultiLevelsValue,
  parseMultiLevelsValue,
} from "./hierarchicalComponentsUtils";

const HierarchicalComponents = ({
  value = "",
  onChange = () => {},
  ...rest
}) => {
  // on any level change event, we rebuild the new value (example: "roof.beam")
  const onSubComponentSelected = (newSlugLevel, newSlugValue) =>
    onChange(buildMultiLevelsValue({ value, newSlugLevel, newSlugValue }));

  return (
    <ComponentsSelector
      selectedSlugs={parseMultiLevelsValue(value)}
      level={0}
      onSubComponentSelected={onSubComponentSelected}
      {...rest}
    />
  );
};

export default HierarchicalComponents;
